import { useState } from "react";
import { nriFaqData, nriWhatsappUrl } from "../../data/nriTaxData";
import { ChevronDown, ArrowRight } from "lucide-react";

const FaqItem = ({ faq, index }) => {
  const [open, setOpen] = useState(false);

  return (
    <div
      className={`border transition-all duration-300 rounded-sm overflow-hidden ${
        open
          ? "border-[#3f4816]/30 bg-[#302f2c]/50"
          : "border-[#3f4816]/10 bg-[#302f2c]/20 hover:border-[#3f4816]/25"
      }`}
    >
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between px-7 py-5 text-left"
        data-testid={`nri-faq-${index}`}
      >
        <span
          className="text-[#dfddd6] font-semibold text-sm leading-snug pr-4"
          style={{ fontFamily: "'Inter', Arial, sans-serif" }}
        >
          {faq.question}
        </span>
        <ChevronDown
          size={16}
          className={`text-[#888680] flex-shrink-0 transition-transform duration-300 ${
            open ? "rotate-180 text-[#d9fb06]" : ""
          }`}
        />
      </button>

      <div
        className="overflow-hidden transition-all duration-300"
        style={{ maxHeight: open ? "600px" : "0", opacity: open ? 1 : 0 }}
      >
        <div className="px-7 pb-6 pt-0">
          {faq.answer.split("\n\n").map((para, i) => (
            <p
              key={i}
              className="text-[#888680] text-sm leading-relaxed mb-3 last:mb-0"
              style={{ fontFamily: "'Inter', Arial, sans-serif" }}
            >
              {para}
            </p>
          ))}
        </div>
      </div>
    </div>
  );
};

export const NriFaqSection = () => {
  return (
    <section id="nri-faq" className="relative py-28" style={{ background: "#1a1c1b" }}>
      <div className="absolute top-0 left-0 right-0 h-px bg-[#3f4816]/30" />
      <div className="max-w-[87.5rem] mx-auto px-10">
        {/* Header */}
        <div className="mb-14">
          <span
            className="inline-block text-[#888680] text-xs font-medium uppercase tracking-[0.2em] mb-5"
            style={{ fontFamily: "'Inter', Arial, sans-serif" }}
          >
            {nriFaqData.sectionLabel}
          </span>
          <h2
            className="font-black uppercase leading-[0.88]"
            style={{
              fontFamily: "'Inter', Arial, sans-serif",
              fontSize: "clamp(1.8rem, 1.4rem + 2vw, 3.2rem)",
              letterSpacing: "-0.02em",
            }}
          >
            <span className="text-[#dfddd6]">{nriFaqData.headline} </span>
            <span className="text-[#d9fb06]">{nriFaqData.headlineAccent}</span>
          </h2>
        </div>

        {/* FAQ items */}
        <div className="flex flex-col gap-2 max-w-4xl mb-12">
          {nriFaqData.faqs.map((faq, i) => (
            <FaqItem key={i} faq={faq} index={i} />
          ))}
        </div>

        {/* CTA */}
        <div className="flex flex-col gap-3 max-w-4xl">
          <p
            className="text-[#888680] text-sm"
            style={{ fontFamily: "'Inter', Arial, sans-serif" }}
          >
            Still have a question? Send me a message.
          </p>
          <a
            href={nriWhatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nri-faq-cta"
            className="group inline-flex items-center gap-2 bg-[#d9fb06] text-[#1a1c1b] font-semibold text-xs px-6 py-3.5 rounded-full transition-all duration-300 hover:scale-[1.02] hover:opacity-90 active:scale-[0.98] uppercase tracking-tight self-start"
            style={{ fontFamily: "'Inter', Arial, sans-serif" }}
          >
            WhatsApp Me "AUDIT"
            <ArrowRight size={13} className="transition-transform duration-300 group-hover:translate-x-0.5" />
          </a>
        </div>
      </div>
    </section>
  );
};
